<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="navbar">
    <div class="accueil">
      <!-- img -->
      <a @click="handleNavigation('/')" class="home">Accueil</a>
      <b-modal v-model="modalShow" id="my-modal">
        Si tu sors de l'immersion, tu pourras revenir directement à cette étape mais tu devras la recommencer. Es-tu
        sûr·e de vouloir sortir ?
        <template v-slot:modal-footer>
          <div>
            <b-button style="margin-right: 20px;" variant="primary" @click="modalShow = false">Annuler</b-button>
            <b-button style="margin-right: 20px;" variant="secondary" @click="continueNavigation()">Sortir</b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <div class="nav-right">
      <a @click="handleNavigation('/blog')">Blog</a>
      <a @click="handleNavigation('/a-propos')">À propos</a>
      <a href="https://www.instagram.com/exploreve_scout/">
        <img src="https://cdn.exploreve.fr/content/social/instagram.svg" alt="Instagram" />
      </a>
      <a href="https://www.facebook.com/ExploreveScout">
        <img src="https://cdn.exploreve.fr/content/social/facebook.svg" alt="Facebook" />
      </a>
      <a href="https://twitter.com/ExploreveScout">
        <img src="https://cdn.exploreve.fr/content/social/twitter.svg" alt="Twitter" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      modalShow: false,
      targetUrl: ""
    };
  },
  methods: {
    handleNavigation(targetUrl) {
      if (this.isInImmersion()) {
        this.targetUrl = targetUrl;
        this.modalShow = true;
      } else if (this.$route.path !== targetUrl) {
        this.$router.push(targetUrl);
      }
    },
    isInImmersion() {
      const immersionUrlRegexp = new RegExp(/\/immersion\d{2}\/\d+/);
      return immersionUrlRegexp.test(this.$route.path);
    },
    continueNavigation() {
      this.$router.push(this.targetUrl);
    }
  }
};
</script>

<style scoped lang="scss">
.navbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: $light;
  z-index: 10;
  padding: 0;
  color: $grey;

  a,
  a:hover,
  a:active {
    color: $grey !important;
    text-decoration: none !important;
    cursor: pointer;
  }

  div {
    * {
      padding: 10px 20px;
    }

    a {
      color: $grey;
      text-decoration: none;
      position: relative;
      display: inline-block;

      &:hover {
        text-decoration: none;
        color: $grey;
        text-decoration: none;
        background-color: rgba($primary, 0.3);
      }

      img {
        height: 24px;
        padding: 0;
      }
    }
  }

  @media screen and (max-width: $breakpoint-md - 1px) {
    .nav-right {
      display: flex;
      width: 100%;
      justify-content: space-evenly;

      a {
        padding: 8px 10px;
      }
    }
  }

  .accueil {
    font-weight: 300;
    font-size: 18pt;

    .home {
      font-weight: 600;
      font-size: 20pt;
      cursor: pointer;
    }
  }
}
</style>
